import { COUNTRY_BY_DEFAULT, Language, LANGUAGE_BY_DEFAULT, UnitSystem, Role, TimezoneTypeEnum } from '../constants';
import { UserAssignedHub, UserOwnerReadModel, UserRolesModel } from '../../store';
import { AssignableCompartmentList } from '../../container-components';
import {
  ProfileEstimatedDeliveryDateTypeEnum,
  ProfileShipmentViewMode,
} from '../../store/state/administration/profile/constants';

export class UserBaseModel {
  id?: number;
  department = '';
  email = '';
  firstName = '';
  lastName = '';
  defaultLanguage: Language = LANGUAGE_BY_DEFAULT;
  country: string = COUNTRY_BY_DEFAULT;
  roles: Role[] | UserRolesModel = [];
  approvedRoles: Role[] = [];
  owners: UserOwnerReadModel[];
  assignedHubs: UserAssignedHub[];
  assignedCompartments: AssignableCompartmentList[];
  timezone = '';
  twentyFourHourTime = false;
  renderTimezone: TimezoneTypeEnum = TimezoneTypeEnum.Selected;
  masterOfRolesAssignedRoles: Role[] | UserRolesModel = [];
  unitSystem: UnitSystem = UnitSystem.Metric;
  estimatedDeliveryDateType: ProfileEstimatedDeliveryDateTypeEnum = ProfileEstimatedDeliveryDateTypeEnum.Auto;
  defaultShipmentViewMode: ProfileShipmentViewMode = ProfileShipmentViewMode.Load;
  includeDeliveryDateInShipmentView = false;
  includeMaterialsInShipmentView = false;
}
